import { createSelector } from '@reduxjs/toolkit';

/**
 * Memoized selector that combines all AddUserModal data.
 */
export const selectAddUserModalState = createSelector(
  [
    (state) => state.userStore.assignedGrandfatherClientNumber,
    (state) => state.userStore.loggedInUser,
    (state) => state.userStore.assignedAccountNumber,
    (state) => state.assignRolesList.roles,
    (state) => state.userStore.userEmailLookupLoaded,
    (state) => state.userStore.userEmailLookupLoading,
    (state) => state.userStore.userEmailLookupError,
    (state) => state.userStore.userEmailLookup,
    (state) => state.userStore.searchUserExists,
    (state) => state.userStore.searchUserExistsLoaded,
    (state) => state.userStore.searchUserExistsLoading,
    (state) => state.userStore.searchUserExistsError,
    (state) => state.userStore.adminSearchUserExists,
    (state) => state.userStore.adminSearchUserExistsLoaded,
    (state) => state.userStore.adminSearchUserExistsLoading,
    (state) => state.userStore.adminSearchUserExistsError,
    (state) => state.userStore.createUserLoading,
    (state) => state.userStore.createUserLoaded,
    (state) => state.modalStore.primaryActionButton,
    (state) => state.modalStore.secondaryActionButton,
    (state) => state.userStore.canReadWriteUsers,
  ],
  (
    assignedGrandfatherClientNumber,
    loggedInUser,
    assignedAccountNumber,
    assignRolesList,
    userEmailLookupLoaded,
    userEmailLookupLoading,
    userEmailLookupError,
    userEmailLookup,
    searchUserExists,
    searchUserExistsLoaded,
    searchUserExistsLoading,
    searchUserExistsError,
    adminSearchUserExists,
    adminSearchUserExistsLoaded,
    adminSearchUserExistsLoading,
    adminSearchUserExistsError,
    createUserLoading,
    createUserLoaded,
    primaryActionButton,
    secondaryActionButton,
    canReadWriteUsers
  ) => ({
    assignedGrandfatherClientNumber,
    loggedInUser,
    assignedAccountNumber,
    assignRolesList,
    userEmailLookupLoaded,
    userEmailLookupLoading,
    userEmailLookupError,
    userEmailLookup,
    searchUserExists,
    searchUserExistsLoaded,
    searchUserExistsLoading,
    searchUserExistsError,
    adminSearchUserExists,
    adminSearchUserExistsLoaded,
    adminSearchUserExistsLoading,
    adminSearchUserExistsError,
    createUserLoading,
    createUserLoaded,
    primaryActionButton,
    secondaryActionButton,
    canReadWriteUsers,
  })
);
